import { concatErrorCache, defaultTags, providesList } from '../../../utils/RTK/utils';
import {
    enhancedApi,
    PathFilter as _PathFilter,
    Path as _Path,
    PostApiV1UnderwritingPathsByPathIdApiArg as _PostApiV1UnderwritingPathsByPathIdApiArg,
} from './generated';
// import { get } from 'lodash';

export const addTagTypes = [...defaultTags, 'Path'] as const;
//lol... it works,right?
export type PathFilter = Required<
    Omit<_PathFilter, 'filterValues'> & {
        filterValues: NonNullable<Pick<_PathFilter, 'filterValues'>['filterValues']>;
    }
>;
export type Path = Required<Omit<_Path, 'pathFilterModels' | 'isDeleted'>> & {
    pathFilterModels: PathFilter[];
    isDeleted?: boolean;
};
export type PostApiV1UnderwritingPathsByPathIdApiArg = Omit<_PostApiV1UnderwritingPathsByPathIdApiArg, 'path'> & {
    path: Path;
};

export const enhanceEndpoints = enhancedApi
    .enhanceEndpoints({
        addTagTypes,
        endpoints: {
            postApiV1UnderwritingPaths: {
                invalidatesTags: [{ type: 'Path', id: 'LIST' }],
            },
            getApiV1UnderwritingPaths: {
                providesTags: providesList('Path', 'pathId'),
            },
            getApiV1UnderwritingPathsByPathId: {
                providesTags: (result, error, arg) =>
                  result ? [{ type: 'Path', id: arg.pathId }] : [],
              },
            postApiV1UnderwritingPathsByPathId: {
                invalidatesTags: (result, error, arg) => [
                    { type: 'Path', id: 'LIST' },
                    { type: 'Path', id: arg.pathId },
                ],
            },
            deleteApiV1UnderwritingPathsByPathId: { 
                invalidatesTags: [{ type: 'Path', id: 'LIST' }] 
            },
        },
    });
